export const REST_SETTINGS_REQUEST = 'REST_SETTINGS_REQUEST'
export const REST_SETTINGS_SUCCESS = 'REST_SETTINGS_SUCCESS'
export const REST_SETTINGS_FALIURE = 'REST_SETTINGS_FALIURE'
export const REST_SETTINGSUPDATE_REQUEST = 'REST_SETTINGSUPDATE_REQUEST'
export const REST_SETTINGSUPDATE_SUCCESS = 'REST_SETTINGSUPDATE_SUCCESS'
export const REST_SETTINGSUPDATE_FALIURE = 'REST_SETTINGSUPDATE_FALIURE'
